<template>
  <div class="menusCheck mainBox">
    <div class="menusCheckLeft wow animate__animated animate__slideInLeft">
      <div class="menusCheckItem" v-for="(item, index) in solutionList" :key="index"
        :class="[active == index && 'menusCheckActive']" @mouseenter="clickMenu(item,index)"
        @click="goSolution(item.type)">
        {{ item.name }}
      </div>
    </div>
    <div class="menusCheckRight wow animate__animated animate__slideInRight">
      <div class="rightBox">
        <OssImg :src="solutionList[active].img" class="rightImg"  alt="" />
        <!-- <div class="intro mariaNoShadow">
          <div>实验室综合管理平台</div>
          <div>
            集资源管理、流程控制、数据监测于一体，实现分类分级、项目信息、基础使用信息一体化管理，实验室管理轻松准确。
          </div>
          <div class="gridBox">
            <div>实验室管理</div>
            <div>分类分级管理</div>
            <div>风险信息</div>
            <div>实验课题组</div>
            <div>危险源管控</div>
            <div>物联设备监控</div>
            <div>动态化监控与预警</div>
            <div>安全合规性</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { navTo } from "@/utils/util";
import { ref } from "vue";
import { useStore } from 'vuex'

const store = useStore()
const solutionList = ref([
  {
    name: "实验室信息化管理方案",
    img: "images/pdtSoft1.png",
    type:'labInfo'
  },
  {
    name: "室内危化品库房改造方案",
    img: "/UIV3/labDanger.png",
    type:'indoorDanger'
  },
  {
    name: "实验室AI智能管控方案",
    img: "/UIV3/labAi.png",
    type:'aiLab'
  },
  {
    name: "室外危废集中存储方案",
    img: "/UIV3/outDanger.png",
    type:'outDanger'
  },
  {
    name: "实验室废水处置方案",
    img: "/UIV3/labWater.png",
    type:'labDanger'
  },
]);

//行业解决方案
const active = ref(0);
const clickMenu = (item,index) => {
  active.value = index
}

const goSolution = (type) => {
  store.commit('lab/SET_LABTYPE',type)
  navTo('/solution/index')
}

</script>

<style lang="scss" scoped>
.menusCheck {
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  .menusCheckLeft {
    width: 33%;
    margin-right: 3.25rem;

    .menusCheckItem {
      font-weight: bold;
      font-size: 1.5rem;
      padding: 1.5rem 0 1rem 0 ;
      border-bottom: 0.0625rem solid #e5e6eb;
      cursor: pointer;
      transition: all 0.3s;
      color: #424242;

      &:hover {
        transform: scale(1.02);
        color: #32A89E;
        border-bottom: 0.0625rem solid #32A89E;
      }
    }

    .menusCheckActive {
      color: #32A89E;
      border-bottom: 0.0625rem solid #32A89E;
    }
  }

  .menusCheckRight {
    flex: 1;

    .rightBox {
      width: 100%;
      position: relative;

      .rightImg {
        width:100%;
        height: 33.9375rem;
      }

      .intro {
        width: 25rem;
        position: absolute;
        right: -8rem;
        top: -5rem;
        padding: 1rem 1.5rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        background: #ffffff;
        box-shadow: 0px 0px 20px #0000001a;

        >div:first-of-type {
          color: #212121;
          font-weight: 500;
          font-size: 1rem;
          margin-bottom: 1rem;
        }

        >div:nth-of-type(2) {
          color: #212121;
          font-weight: 500;
          font-size: 0.875rem;
          margin-bottom: 1.5rem;
          text-align: justify;
        }
      }

      .gridBox {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        color: #424242;
        font-weight: 500;
        font-size: 0.875rem;
        gap: 2rem;
      }
    }
  }
}

// @media(max-width:768px) {
//   .menusCheck {
//     flex-direction: column;
//     margin-top: 0;

//     .menusCheckLeft {
//       width: 100%;
//       margin: auto;

//       .menusCheckItem {
//         font-size: 5vw;
//       }
//     }

//     .menusCheckRight {
//       width: 100vw;

//       .rightImg {
//         position: relative !important;
//         width: 100% !important;
//         object-fit: contain !important;
//       }

//       .intro {
//         position: relative !important;
//         left: 50%;
//         transform: translateX(-50%);
//         top: 0;
//       }
//     }
//   }
// }
</style>
